// extracted by mini-css-extract-plugin
module.exports = {"indication":"IndicationComponent_indication__1kTM-"};